import type { Repub } from '@cx-modules/constants';

export const SHOW_AGREE_TERMS_AS_CHECKBOX_CONFIG: Record<Repub, boolean> = {
  AU: false,
  BR: false,
  CA: false,
  CO: false,
  CX: false,
  DE: false,
  DK: false,
  ES: false,
  FR: false,
  GZ: true,
  IN: false,
  IT: true,
  KE: false,
  MX: false,
  NG: false,
  NL: false,
  NZ: false,
  OC: true,
  PT: false,
  SE: false,
  SM: false,
  US: false,
  WS: true,
  XX: false,
  ZA: false,
};

// Whether the non-plus signup flow signs the user in immediately after registering, vs
// showing a check-your-email screen and requiring the user to verify before logging in.
export const SIGN_IN_IMMEDIATELY_AFTER_SIGNUP_CONFIG: Record<Repub, boolean> = {
  AU: true,
  BR: true,
  CA: true,
  CO: true,
  CX: true,
  DE: true,
  DK: true,
  ES: true,
  FR: true,
  GZ: true,
  IN: true,
  IT: true,
  KE: true,
  MX: true,
  NG: true,
  NL: true,
  NZ: true,
  OC: false,
  PT: true,
  SE: true,
  SM: true,
  US: true,
  WS: true,
  XX: true,
  ZA: true,
};
